const abbreviations = [
    "COTAD",
    "Circle Of The Awesomely Different",
    "Church Of The Amazingly Dreamers",
    "Choose Openness To Accept Differences",
    "Crisis Operation Team Against Discrimination",
    "Circle Of The Accepting Drum",
    "Conquer Our Troubles And Differences",
    "Caring Outreach To All Diversity",
    "Cool Organization That Accepts Diversity",
    "Cast Out The Awful Discrimination",
    "Cozy Oasis To Accept Differences",
    "Champion Of The Accepting Dream",
    "Cultivate Openness To Accept Differences",
    "Cultivate Our Tolerance And Diversity",
    "Corral Our Troubles And Differences",
    "Community Of Thoughtful And Diverse",
    "Circle Of Tolerance And Development",
    "Creating Opportunities Through Active Dialogue",
    "Celebration Of Talent And Distinction",
    "Connecting Our Teams Advancing Diversity",
    "Coalition Of Thinkers Accepting Differences",
    "Colors Of The Accepting Dawn",
    "Catalyst Of Transformative And Dynamic",
    "Chorus Of The Accepting Dreamers",
    "Champions Of Tolerance And Democracy",
    "Composing Our Tomorrow's Amazing Design",
    "Collective Of Talented And Determined",
    "Caring Organization That Advocates Diversity",
    "Creating Opportunities To Advance Development",
    "Collaboration Of Teams Achieving Dreams",
    "Circle Of Trust And Determination",
    "Community Of Thinkers And Doers",
    "Cultivating Optimism Through Active Dialogue",
    "Covenant Of The Accepting Diversity",
    "Crafting Our Tomorrow's Amazing Destiny",
    "Coven Of The Ancient Dragons",
    "Church Of The Almighty Dwarves",
    "Church Of The Anointed Dove",
    "Church Of The Ascending Dawn",
    "Conclave Of The Astral Dreamers",
    "Circle Of Traditions And Dragons",
    "Companions Of The Ancient Depths",
    "Council Of The Arcane Dancers",
    "Crusade Of The Awakened Dawn",
    "Creators Of Tomorrow's Amazing Destiny",
    "Celestial Order Teaching Ancient Disciplines",
    "Congregation Of The Accepting Dragons",
    "Chronicles Of The Awakened Druids",
    "Custodians Of The Ancient Doorway",
    "Covenant Of The Astral Dancers",
    "Circle Of Transcendent Ancient Designs",
    "Calling Of The Ancient Dragons",
    "Collective Of Transformative Art Directors",
    "Caretakers Of The Astral Dimension",
    "College Of The Ancient Disciplines",
    "Council Of The Accepting Dragons",
    "Chorus Of The Ancient Druids",
    "Conservatory Of Traditional Arts Development",
    "Conclave Of The Awakened Dreamweavers",
    "Collectors Of Timeless Astral Documents",
    "Circle Of The Ascending Disciples",
    "Covenant Of Transcendent Arcane Development",
    "Craftsmen Of The Ancient Designs",
    "Companions Of The Astral Dimension",
    "Curators Of Traditional Artistic Disciplines",
    "Champions Of The Ascending Dawn",
    "Court Of The Ancient Dreamers",
    "Community Of Thoughtful Artistic Development",
    "Creators Of Transformative Artistic Designs",
    "Chroniclers Of The Astral Dimensions",
    "Custodians Of Traditional Ancient Disciplines",
    "Circle Of The Awakened Dragons",
    "Craftspeople Of Today's Artistic Developments",
    "Cartographers Of Twilight And Dawn",
    "Conductors Of Thunderous Acoustic Displays",
    "Collectors Of Treasured Ancestral Discoveries",
    "Coalescence Of Temporal Artistic Dimensions",
    "Crafters Of Timeless Alchemical Drafts",
    "Captains Of Transformative Adventure Destinations",
    "Cultivators Of Thoughtful Academic Discourse",
    "Chanters Of Timeless Arcane Directives",
    "Coordinators Of Therapeutic Artistic Development",
    "Counselors Of Tomorrow's Ambitious Dreamers",
    "Cauldron Of Theoretical Astronomical Discoveries",
    "Collectors Of Tales And Declarations",
    "Creators Of Transformative Adventure Diaries",
    "Consortium Of Talented Aspiring Dreamweavers",
    "Confluence Of Theatrical Artistic Dimensions"
].sort(() => Math.random() - 0.5);

export default abbreviations;